<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterMonth"
              :editedCustomerIndex="-1"
              :customerName="'quotation_shortname'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_item_month_number')"
              v-model="filterMonth.Number"
              @input="getAllMonth"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterMonth.LicensePlate"
              @input="getAllMonth"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="monthDataTableHeaders"
      :items="monthList"
      class="elevation-1 my-5"
      :loading="isLoadingMonth"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('month_tool_bar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="isShowEditMonthDialog" fullscreen persistent>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t('common_look') }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.Number"
                        :label="$t('quotation_item_month_number')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.ItemNumber"
                        :label="$t('month_number')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.ItemName"
                        :label="$t('month_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.CustomerNumber"
                        :label="$t('quotation_customer_number')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.CustomerName"
                        :label="$t('quotation_shortname')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.CustomerFullName"
                        :label="$t('quotation_full_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.LicensePlate"
                        :label="$t('quotation_license_plate')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.MonthQuantity"
                        :label="$t('month_quantity')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnStartDate"
                        :label="$t('month_start_date')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnEndDate"
                        :label="$t('month_end_date')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnStopDate"
                        :label="$t('month_stop_date')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnDoneDate"
                        :label="$t('month_done_date')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.OriginalCurrency"
                        :label="$t('month_original_currency')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.DomesticCurrency"
                        :label="$t('month_domestic_currency')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.RentWarrantyPeriod"
                        :label="$t('quotation_item_rent_warranty_period')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.RentDay"
                        :label="$t('month_rent_day')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnMonthStatus"
                        :label="$t('month_rent_status')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.GiveDay"
                        :label="$t('month_give_day')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnExpectedRemoveDate"
                        :label="$t('month_expected_remove_date')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.UnUseDay"
                        :label="$t('month_not_use_day')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.UseDay"
                        :label="$t('month_use_day')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnLastPayDate"
                        :label="$t('month_last_pay_date')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-checkbox
                        v-model="editedMonth.IsEnd"
                        :label="$t('month_is_end')"
                        disabled
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-tabs>
                <v-tab href="#tab-1">{{ $t('month_item_tab') }}</v-tab>
                <v-tab href="#tab-2">{{ $t('month_sale_item_tab') }}</v-tab>

                <v-tab-item value="tab-1">
                  <v-card flat>
                    <v-card-text>
                      <v-data-table
                        :headers="monthItemDataTableHeaders"
                        :items="editedMonth.MonthItems"
                        :search="searchMonthItem"
                        class="elevation-1"
                        :no-data-text="$t('common_no_data')"
                        :no-results-text="$t('common_no_results')"
                        :footer-props="{
                          'items-per-page-options': [30, 50, 100],
                          'items-per-page-text': $t('item_rows_per_page'),
                        }"
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-spacer></v-spacer>
                            <v-text-field
                              v-model="searchMonthItem"
                              append-icon="mdi-magnify"
                              :label="$t('quotation_item_new_install_search')"
                              single-line
                              hide-details
                              clearable
                            ></v-text-field>
                          </v-toolbar>
                        </template>
                        <template v-slot:[`item.ChangeDate`]="{ item }">
                          {{ convertToDateTimeFormat(item.ChangeDate) }}
                        </template>
                        <template v-slot:[`item.MonthItemStatus`]="{ item }">
                          {{ turnMonthItem(item.MonthItemStatus) }}
                        </template>
                        <template v-slot:[`item.NumberType`]="{ item }">
                          {{ turnNumberType(item.NumberType) }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-2">
                  <v-card flat>
                    <v-card-text>
                      <v-data-table
                        :headers="saleItemDataTableHeaders"
                        :items="editedMonth.SaleItems"
                        :search="searchSaleItem"
                        class="elevation-1"
                        :no-data-text="$t('common_no_data')"
                        :no-results-text="$t('common_no_results')"
                        :footer-props="{
                          'items-per-page-options': [30, 50, 100],
                          'items-per-page-text': $t('item_rows_per_page'),
                        }"
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-spacer></v-spacer>
                            <v-text-field
                              v-model="searchSaleItem"
                              append-icon="mdi-magnify"
                              :label="$t('quotation_item_new_install_search')"
                              single-line
                              hide-details
                              clearable
                            ></v-text-field>
                          </v-toolbar>
                        </template>
                        <template v-slot:[`item.ThrowDate`]="{ item }">
                          {{ convertToDateTimeFormat(item.ThrowDate) }}
                        </template>
                        <template v-slot:[`item.StartDate`]="{ item }">
                          {{ convertToDateTimeFormat(item.StartDate) }}
                        </template>
                        <template v-slot:[`item.EndDate`]="{ item }">
                          {{ convertToDateTimeFormat(item.EndDate) }}
                        </template>
                        <template v-slot:[`item.PayType`]="{ item }">
                          {{ turnPayType(item.PayType) }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedMonth"
                  :disabled="isAllTextFieldDisable"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditMonthBtn(item)">
          <v-icon small>
            mdi-eye
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpMonth } from '@/js/http-Manager'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import { MonthStatus } from '@/js/MonthStatus'
import { MonthItemStatus } from '@/js/MonthItemStatus'
import { NumberType } from '@/js/NumberType'
import { PayType } from '@/js/PayType'

export default {
  name: 'Month',
  components: { CustomerAutocompleteFilter },
  data: () => ({
    isShowEditMonthDialog: false,
    monthList: [],
    editedMonthIndex: -1,

    editedMonth: {
      Number: '',
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      LicensePlate: '',
      MonthQuantity: 0,
      StartDate: 0,
      EndDate: 0,
      StopDate: 0,
      DoneDate: 0,
      OriginalCurrency: 0,
      DomesticCurrency: 0,
      RentWarrantyPeriod: 0,
      RentDay: 0,
      MonthStatus: 0,
      GiveDay: 0,
      ExpectedRemoveDate: 0,
      UnUseDay: 0,
      UseDay: 0,
      IsEnd: false,
      LastPayDate: 0,
      MonthItems: [],
      SaleItems: []
    },
    defaultMonth: {
      Number: '',
      CustomerId: '',
      ItemId: '',
      LicensePlate: '',
      MonthQuantity: 0,
      StartDate: 0,
      EndDate: 0,
      StopDate: 0,
      DoneDate: 0,
      OriginalCurrency: 0,
      DomesticCurrency: 0,
      RentWarrantyPeriod: 0,
      RentDay: 0,
      MonthStatus: 0,
      GiveDay: 0,
      ExpectedRemoveDate: 0,
      UnUseDay: 0,
      UseDay: 0,
      IsEnd: false,
      LastPayDate: 0,
      MonthItems: [],
      SaleItems: []
    },
    isLoadingMonth: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    isShowDeleteMonthDialog: false,
    isLoadingDeleteBtn: false,
    isDeleteBtnDisable: false,
    currentOptions: {
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: true,
    totalRows: 0,
    filterMonth: {
      Number: '',
      CustomerId: '',
      LicensePlate: ''
    },
    searchMonthItem: '',
    searchSaleItem: ''
  }),
  async mounted () {
    await this.getAllMonth()
    await this.countTotalRows()
  },
  computed: {
    monthDataTableHeaders () {
      return [
        {
          text: this.$t('quotation_item_month_number'),
          align: 'start',
          value: 'Number'
        },
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('item_number'), align: 'start', value: 'ItemNumber' },
        { text: this.$t('item_name'), align: 'start', value: 'ItemName' },
        {
          text: this.$t('quotation_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        {
          text: this.$t('common_look'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    dialogTitleHeader () {
      return this.editedMonthIndex === -1
        ? this.$t('point_new_card_title')
        : this.$t('point_edited_card_title')
    },
    turnStartDate () {
      return this.convertToDateTimeFormat(this.editedMonth.StartDate)
    },
    turnEndDate () {
      return this.convertToDateTimeFormat(this.editedMonth.EndDate)
    },
    turnStopDate () {
      return this.convertToDateTimeFormat(this.editedMonth.StopDate)
    },
    turnDoneDate () {
      return this.convertToDateTimeFormat(this.editedMonth.DoneDate)
    },
    turnExpectedRemoveDate () {
      return this.convertToDateTimeFormat(this.editedMonth.ExpectedRemoveDate)
    },
    turnLastPayDate () {
      return this.convertToDateTimeFormat(this.editedMonth.LastPayDate)
    },
    turnMonthStatus () {
      return MonthStatus.MonthStatusName(this.editedMonth.MonthStatus)
    },
    monthItemDataTableHeaders () {
      return [
        {
          text: this.$t('month_item_change_date'),
          align: 'start',
          value: 'ChangeDate'
        },
        { text: this.$t('month_item_status'), align: 'start', value: 'MonthItemStatus' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        {
          text: this.$t('quotation_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        { text: this.$t('month_quantity'), align: 'start', value: 'MonthQuantity' },
        {
          text: this.$t('month_item_is_throw_sale_detail'),
          align: 'start',
          value: 'IsThrowSaleDetail'
        },
        { text: this.$t('month_item_original_number'), align: 'start', value: 'NumberType' },
        { text: this.$t('month_sale_item_tab'), align: 'start', value: 'OriginalNumber' }
      ]
    },
    saleItemDataTableHeaders () {
      return [
        {
          text: this.$t('month_sale_item_settle_day'),
          align: 'start',
          value: 'SettleDay'
        },
        { text: this.$t('month_original_currency'), align: 'start', value: 'OriginalCurrency' },
        { text: this.$t('month_domestic_currency'), align: 'start', value: 'DomesticCurrency' },
        {
          text: this.$t('month_sale_item_sale_type'),
          align: 'start',
          value: 'SaleType'
        },
        { text: this.$t('month_sale_item_sale_number'), align: 'start', value: 'SaleNumber' },
        { text: this.$t('month_sale_item_sale_sort'), align: 'start', value: 'SaleSort' },
        { text: this.$t('month_sale_item_throw_date'), align: 'start', value: 'ThrowDate' },
        { text: this.$t('month_sale_item_start_date'), align: 'start', value: 'StartDate' },
        { text: this.$t('month_sale_item_end_date'), align: 'start', value: 'EndDate' },
        { text: this.$t('month_sale_item_pay_day'), align: 'start', value: 'PayDay' },
        { text: this.$t('month_sale_item_pay_type'), align: 'start', value: 'PayType' },
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('quotation_license_plate'), align: 'start', value: 'LicensePlate' },
        { text: this.$t('month_quantity'), align: 'start', value: 'MonthQuantity' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' }
      ]
    }
  },
  methods: {
    turnNumberType (val) {
      return NumberType.NumberTypeName(val)
    },
    turnPayType (val) {
      return PayType.PayTypeName(val)
    },
    turnMonthItem (val) {
      return MonthItemStatus.MonthItemStatusName(val)
    },
    async setFilterCustomer (val) {
      this.filterMonth.CustomerId = val.Id
      this.filterMonth = JSON.parse(JSON.stringify(this.filterMonth))
      await this.getAllMonth()
      await this.countTotalRows()
    },
    async getAllMonth (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isLoadingMonth = true
      let param = {
        Number: this.filterMonth.Number,
        CustomerId: this.filterMonth.CustomerId,
        LicensePlate: this.filterMonth.LicensePlate,
        ItemsPerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy,
        SortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy
      }
      let response = await HttpMonth.GetMonth(param)
      this.isLoadingMonth = false
      this.monthList = response.status === 200 ? response.data.Data : []
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          Number: this.filterMonth.Number,
          CustomerId: this.filterMonth.CustomerId,
          LicensePlate: this.filterMonth.LicensePlate
        }
        let response = await HttpMonth.GetMonthCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getAllMonth(val)
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditMonthBtn (item) {
      this.editedMonthIndex = this.monthList.indexOf(item)
      this.editedMonth = JSON.parse(JSON.stringify(item))
      this.isShowEditMonthDialog = true
    },
    closeEditedMonth () {
      this.isShowEditMonthDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false

      this.$nextTick(() => {
        this.editedMonth = JSON.parse(JSON.stringify(this.defaultMonth))
        this.editedMonthIndex = -1
      })
    }
  }
}
</script>
